// GENERATED by scripts/build-icons.mjs from icons/file-text.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const FileText = createIcon('file-text', [
  ['path', { d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" }],
  ['path', { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
  ['path', { d: "M10 9H8" }],
  ['path', { d: "M16 13H8" }],
  ['path', { d: "M16 17H8" }],
])
